import styled from '@emotion/styled'

export const ScenarioListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  width: 100%;
  margin-top: 2rem;
  padding: 1rem;
  padding-right: 1.7rem;
  box-sizing: border-box;
`

export const ScenarioContent = styled.div`
  padding: 0rem;
`
